/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { AirCalendarList } from '../../models/air-calendar-list';
import { FinnairSearchParameters } from '../../models/finnair-search-parameters';

export interface FindAirCalendar$Params {
      body: FinnairSearchParameters
}

export function findAirCalendar(http: HttpClient, rootUrl: string, params: FindAirCalendar$Params, context?: HttpContext): Observable<DapiHttpResponse<AirCalendarList>> {
  const rb = new DapiRequestBuilder(rootUrl, findAirCalendar.PATH, 'post');

  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<AirCalendarList>;
    }),
    catchErrorAsJson()
  );
}

findAirCalendar.PATH = '/api/airCalendar';
